import { ModelBase } from '../../core/model/model-base';

export class InvoiceRowGroup extends ModelBase {
  caption: string;
}
